"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_accelerometer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "2fa85713-4a06-4300-92b1-b7603bc2c2d9",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4e5fd338-0c52-4eae-a604-9a35f435adf0",
    x1: 112.74,
    y1: -480.36,
    x2: 169.77,
    y2: -537.38,
    gradientTransform: "matrix(1, 0, 0, -1, 0, -402)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "accelerometer-hi"), /*#__PURE__*/React.createElement("g", {
    id: "b8f7f757-3f7d-4733-b320-62db9a58e9d0",
    "data-name": "ca239d33-7af1-4ee7-a7e7-de04e9c627ed"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b366cdd2-3278-42f9-b407-ee76e997a999",
    "data-name": "297c8bce-ad82-43ca-81ff-dc494588329b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b693a566-fe7d-4a95-9760-877621582ddc",
    "data-name": "79dd82aa-7f90-4b0a-827d-e4387f151ea4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e627a762-53c8-4c8c-b771-51cde15ba3ad",
    "data-name": "bb5ca9ea-786d-43b6-a968-268cce7fb1eb"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9ef09a25-718c-4f0f-8b66-a7d29df60a55",
    "data-name": "c6008d96-1265-4725-93d1-3c0adec4b000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "362e0cf9-f64e-4ce8-a582-3b29813aab2f",
    "data-name": "2515ffe6-9028-481d-b256-64db129ec49f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6face91f-33ae-4666-bf04-5b79e3582250",
    "data-name": "26236544-dd18-4a0c-a21b-740a4424c4e5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d1c88cd9-0bb1-45f4-bea1-e6a7e7ba60e5",
    "data-name": "81b69423-8804-4744-8234-3a0f44cce909"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3e1852d6-b2a2-432c-b685-f156eb0afc4c",
    "data-name": "f1361f1b-d81b-4da1-95ad-76b42dbb15be"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8d10df0d-a6ec-4485-b91d-b349103b5379",
    "data-name": "cc6278a2-8699-4ec2-ad50-7e57af75c84b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "69e94efa-839c-43ee-98cc-31ffc0eeebef",
    "data-name": "8511fd9c-dace-497f-a988-09d1dd4a4819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "973bdac0-ddfa-4dc3-8329-936538e877a9",
    "data-name": "4fcde42a-d653-4958-bc95-8719af0841b4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a9111d72-d602-4fa9-b38f-0c9ebea0453c",
    "data-name": "2d583a03-c55c-4dbf-a46b-ae0ba7424903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4fedffe3-33f3-494f-a552-3f40d4ff2953",
    "data-name": "9fb3d8a4-b20e-4547-a73f-25fbd0533359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1870c978-dbcf-4d72-9ec9-28b93f112e57",
    "data-name": "d2bb4838-d886-4598-a407-dd42cdf47bb1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "870da55e-e457-4320-b382-fa0d83753606",
    "data-name": "11f0804a-efde-4c6e-bb2f-63b584a12512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "219a3450-ffd2-44e1-9d9c-86d0a9d7ad1f",
    "data-name": "784de820-2b32-4ffd-b69a-4bbc94493093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7846c217-455d-4767-80e2-48ce96c25677",
    "data-name": "033269b2-ddf2-4470-ab4c-245745df9ea3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4a32774c-1404-4e4d-90c4-ccd45b09f436",
    "data-name": "1937cd4b-d9f3-47af-88dd-5b06fbbcb5de"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d5cc117b-b5e1-4602-8440-e8b86e252a26",
    "data-name": "2084fda6-a716-4487-942d-47c79bd05af8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4ca176c-e707-4b99-be62-cd0a1ff88bd0",
    "data-name": "7d335c61-5e7a-4d0c-a0d6-f5891cff728b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6e10906e-5b52-48ea-b1ec-c0208bf31fd0",
    "data-name": "598e6789-3709-41d8-9a10-07f5715b9d1f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3d2e3b23-5c7a-4d85-b40d-36fbea1a44ac",
    "data-name": "4fc924e3-d55d-4fb6-9499-d87ac1454753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e62e96c4-2b15-4645-a046-12d99cad03ea",
    "data-name": "78fed9a9-4a45-43d8-ac06-4a64e04304b0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "827cb120-2837-4214-a284-8baaa5e6d0c4",
    "data-name": "13dcfa48-5dc0-4a40-abcd-7d138b06ae27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4b7abcdc-f7fd-47f5-b873-cbe544d01315",
    "data-name": "9a84c816-de68-409f-9930-9e2bd813aa0f"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c45913e2-5b82-4d28-8ead-4243678a0b99",
    "data-name": "eb832ee7-5ca1-4d21-8838-13d64d694f4e"
  }, /*#__PURE__*/React.createElement("g", {
    id: "527c3a24-dc87-4b03-a004-0994689551f1",
    "data-name": "0c14d960-2e23-4e76-b754-7b2c07c2a23a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 80,
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174A80,80,0,0,1,16,95v1a80,80,0,0,0,160,0V95A80,80,0,0,1,96,174Z",
    transform: "translate(0 0)",
    opacity: 0.06,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "1f8a5c07-7c82-4097-9be3-48f462aedbf5",
    "data-name": "4490ee3a-b20d-472c-a8ce-2f58853a945b",
    x1: 96,
    y1: 35.54,
    x2: 96,
    y2: 52.54,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "62ecbdf4-5f90-43df-8609-60be8c7563e7",
    "data-name": "1bb5c6ec-33b5-404f-8d2c-b070adae7c3f",
    x1: 52.37,
    y1: 96,
    x2: 35.37,
    y2: 96,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "40975a12-c8e8-485c-9bfb-6581c3a2ce98",
    "data-name": "640b71d9-4284-4eac-8426-791e233d1b40",
    x1: 139.37,
    y1: 95.98,
    x2: 156.37,
    y2: 95.98,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "2d02f034-92c0-4beb-b7a1-0ff60550204f",
    "data-name": "65238655-3ebb-4b80-91fb-13dc833570fe",
    x1: 65.11,
    y1: 65.28,
    x2: 53.09,
    y2: 53.26,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1,104,144,160a79.89,79.89,0,0,0,32-64c0-2-.1-4-.24-5.91l-37.38-37Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#4e5fd338-0c52-4eae-a604-9a35f435adf0)",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 96,
    r: 12,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("line", {
    id: "19e515f2-9c2f-440e-b691-d9c20e0dd7ab",
    "data-name": "d4903cc5-ada7-49b4-9d46-f8d633173db6",
    x1: 104.73,
    y1: 87.77,
    x2: 136,
    y2: 56.5,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,57.48,107.71,88.75a4.4,4.4,0,0,1-.67.54,12.07,12.07,0,0,1,.53,1.57l.14-.11L139,59.48a4.18,4.18,0,0,0,1.1-4A4.08,4.08,0,0,1,139,57.48Z",
    transform: "translate(0 0)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,106a12,12,0,0,1-12-11c0,.33,0,.66,0,1a12,12,0,0,0,24,0,6.7,6.7,0,0,0,0-1A12,12,0,0,1,96,106Z",
    transform: "translate(0 0)",
    opacity: 0.12,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))))))))))))))))))));
}

var _default = ic_accelerometer;
exports.default = _default;